<template id="cmsForm">
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item">
          <a href="/service">service</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          service form
        </li>
      </ol>
    </nav>
    <div class="row">
      <div class="col-md-10">
        <h3>Service Form</h3>
      </div>
    </div>
    <form>
      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">Thumbnail Destop TH</h3>
        </div>
      </div>
      <div class="row border">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">ตัวอย่างภาพ</label>
            <img v-if="form.thumbnail_desktop_th.url != ''" :src="form.thumbnail_desktop_th.url" alt=""
              class="img-thumbnail" />
          </div>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <label for="post_add_thumbnail">ค้นหาภาพ thumbnail desktop TH</label>
            <searchbox @searchButtonClick="seachDesktopThumbnailTH"></searchbox>
            <div class="row">
              <div class="col-md-12 p-1">
                <vue-select-image :dataImages="thumbnails_desktop_th" :useLabel="true" :w="'80px'" :limit="41"
                  @onselectimage="onSelectImageDesktopThumbnailTH">
                </vue-select-image>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="post_add_thumbnail">&nbsp;</label>
            <a id="post_add_thumbnail" href="/media/form" target="_blank"
              class="btn btn-secondary form-control">เพิ่มภาพใหม่</a>
          </div>
        </div>
      </div>
      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">Thumbnail Desktop EN</h3>
        </div>
      </div>
      <div class="row border">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">ตัวอย่างภาพ</label>
            <img v-if="form.thumbnail_desktop_en.url != ''" :src="form.thumbnail_desktop_en.url" alt=""
              class="img-thumbnail" />
          </div>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <label for="post_add_thumbnail">ค้นหาภาพ thumbnail desktop EN</label>
            <searchbox @searchButtonClick="seachDesktopThumbnailEN"></searchbox>
            <div class="row">
              <div class="col-md-12 p-1">
                <vue-select-image :dataImages="thumbnails_desktop_en" :useLabel="true" :w="'80px'" :limit="41"
                  @onselectimage="onSelectImageDesktopThumbnailEN">
                </vue-select-image>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="post_add_thumbnail">&nbsp;</label>
            <a id="post_add_thumbnail" href="/media/form" target="_blank"
              class="btn btn-secondary form-control">เพิ่มภาพใหม่</a>
          </div>
        </div>
      </div>
      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">Thumbnail Mobile TH</h3>
        </div>
      </div>
      <div class="row border">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">ตัวอย่างภาพ</label>
            <img v-if="form.thumbnail_mobile_th.url != ''" :src="form.thumbnail_mobile_th.url" alt=""
              class="img-thumbnail" />
          </div>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <label for="post_add_thumbnail">ค้นหาภาพ thumbnail mobile TH</label>
            <searchbox @searchButtonClick="seachMobileThumbnailTH"></searchbox>
            <div class="row">
              <div class="col-md-12 p-1">
                <vue-select-image :dataImages="thumbnails_mobile_th" :useLabel="true" :w="'80px'" :limit="41"
                  @onselectimage="onSelectImageMobileThumbnailTH">
                </vue-select-image>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="post_add_thumbnail">&nbsp;</label>
            <a id="post_add_thumbnail" href="/media/form" target="_blank"
              class="btn btn-secondary form-control">เพิ่มภาพใหม่</a>
          </div>
        </div>
      </div>
      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">Thumbnail Mobile EN</h3>
        </div>
      </div>
      <div class="row border">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">ตัวอย่างภาพ</label>
            <img v-if="form.thumbnail_mobile_en.url != ''" :src="form.thumbnail_mobile_en.url" alt=""
              class="img-thumbnail" />
          </div>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <label for="post_add_thumbnail">ค้นหาภาพ thumbnail mobile EN</label>
            <searchbox @searchButtonClick="seachMobileThumbnailEN"></searchbox>
            <div class="row">
              <div class="col-md-12 p-1">
                <vue-select-image :dataImages="thumbnails_mobile_en" :useLabel="true" :w="'80px'" :limit="41"
                  @onselectimage="onSelectImageMobileThumbnailEN">
                </vue-select-image>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="post_add_thumbnail">&nbsp;</label>
            <a id="post_add_thumbnail" href="/media/form" target="_blank"
              class="btn btn-secondary form-control">เพิ่มภาพใหม่</a>
          </div>
        </div>
      </div>

      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">Banner for Desktop TH</h3>
        </div>
      </div>
      <div class="row border">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">ตัวอย่างภาพ</label>
            <img v-if="form.banner_desktop_th.url != ''" :src="form.banner_desktop_th.url" alt=""
              class="img-thumbnail" />
          </div>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <label for="post_add_thumbnail">ค้นหาภาพ Banner desktop TH</label>
            <searchbox @searchButtonClick="seachBannerDesktopTH"></searchbox>
            <div class="row">
              <div class="col-md-12 p-1">
                <vue-select-image :dataImages="banners_desktop_th" :useLabel="true" :w="'80px'" :limit="41"
                  @onselectimage="onSelectBannerDesktopTH">
                </vue-select-image>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="post_add_thumbnail">&nbsp;</label>
            <a id="post_add_thumbnail" href="/media/form" target="_blank"
              class="btn btn-secondary form-control">เพิ่มภาพใหม่</a>
          </div>
        </div>
      </div>

      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">Banner for Desktop EN</h3>
        </div>
      </div>
      <div class="row border">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">ตัวอย่างภาพ</label>
            <img v-if="form.banner_desktop_en.url != ''" :src="form.banner_desktop_en.url" alt=""
              class="img-thumbnail" />
          </div>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <label for="post_add_thumbnail">ค้นหาภาพ Banner desktop EN</label>
            <searchbox @searchButtonClick="seachBannerDesktopEN"></searchbox>
            <div class="row">
              <div class="col-md-12 p-1">
                <vue-select-image :dataImages="banners_desktop_en" :useLabel="true" :w="'80px'" :limit="41"
                  @onselectimage="onSelectBannerDesktopEN">
                </vue-select-image>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="post_add_thumbnail">&nbsp;</label>
            <a id="post_add_thumbnail" href="/media/form" target="_blank"
              class="btn btn-secondary form-control">เพิ่มภาพใหม่</a>
          </div>
        </div>
      </div>

      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">Banner for Mobile TH</h3>
        </div>
      </div>
      <div class="row border">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">ตัวอย่างภาพ</label>
            <img v-if="form.banner_mobile_th.url != ''" :src="form.banner_mobile_th.url" alt="" class="img-thumbnail" />
          </div>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <label for="post_add_thumbnail">ค้นหาภาพ Banner mobile TH</label>
            <searchbox @searchButtonClick="seachBannerMobileTH"></searchbox>
            <div class="row">
              <div class="col-md-12 p-1">
                <vue-select-image :dataImages="banners_mobile_th" :useLabel="true" :w="'80px'" :limit="41"
                  @onselectimage="onSelectBannerMobileTH">
                </vue-select-image>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="post_add_thumbnail">&nbsp;</label>
            <a id="post_add_thumbnail" href="/media/form" target="_blank"
              class="btn btn-secondary form-control">เพิ่มภาพใหม่</a>
          </div>
        </div>
      </div>

      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">Banner for Mobile EN</h3>
        </div>
      </div>
      <div class="row border">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">ตัวอย่างภาพ</label>
            <img v-if="form.banner_mobile_en.url != ''" :src="form.banner_mobile_en.url" alt="" class="img-thumbnail" />
          </div>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <label for="post_add_thumbnail">ค้นหาภาพ Banner mobile EN</label>
            <searchbox @searchButtonClick="seachBannerMobileEN"></searchbox>
            <div class="row">
              <div class="col-md-12 p-1">
                <vue-select-image :dataImages="banners_mobile_en" :useLabel="true" :w="'80px'" :limit="41"
                  @onselectimage="onSelectBannerMobileEN">
                </vue-select-image>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="post_add_thumbnail">&nbsp;</label>
            <a id="post_add_thumbnail" href="/media/form" target="_blank"
              class="btn btn-secondary form-control">เพิ่มภาพใหม่</a>
          </div>
        </div>
      </div>

      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">Image of service</h3>
        </div>
      </div>
      <div class="row border">
        <div class="col-md-3">
          <div class="form-group">
          </div>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <label for="post_add_thumbnail">ค้นหาภาพ Service</label>
            <searchbox @searchButtonClick="seachServiceImage"></searchbox>
            <div class="row">
              <div class="col-md-12 p-1">
                <vue-select-image :dataImages="service_images" :useLabel="true" :w="'80px'" :limit="41"
                  @onselectimage="onSelectServiceImage">
                </vue-select-image>
              </div>
            </div>
            <div class="row">
              <div v-for="(image, index) in form.service_image" :key="image.id || index"
                class="col-md-3 p-1 position-relative">
                <img :src="image.url" alt="" class="img-thumbnail" />
                <button type="button" @click="removeServiceImage(index)" class="btn btn-danger btn-sm position-absolute"
                  style="top: 5px; right: 5px;">x</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="post_add_thumbnail">&nbsp;</label>
            <a id="post_add_thumbnail" href="/media/form" target="_blank"
              class="btn btn-secondary form-control">เพิ่มภาพใหม่</a>
          </div>
        </div>
      </div>

      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">ข้อมูลทั่วไป</h3>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="post_status">สถานะ *</label>
            <select class="form-control" v-model="form.status">
              <option></option>
              <option :value="'published'">published</option>
              <option :value="'draft'">draft</option>
              <option :value="'disabled'">disabled</option>
              <option :value="'trash'">trash</option>
            </select>
            <!-- <form-error
              :isError="validateError.status.error"
              :errorMessage="validateError.status.message"
            ></form-error> -->
            <span v-if="errors['status']" class="text-danger">{{ errors['status'][0] }}</span>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label for="post_slug required">slug *</label>
            <input type="text" class="form-control" v-model="form.slug" />
            <!-- <form-error
              :isError="validateError.slug.error"
              :errorMessage="validateError.slug.message"
            ></form-error> -->
            <span v-if="errors['slug']" class="text-danger">{{ errors['slug'][0] }}</span>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label for="post_type required">ชนิด *</label>
            <select class="form-control" aria-describedby="post_type_Help" disabled v-model="form.post_type">
              <option :value="'service_page'">Service</option>
            </select>
            <span v-if="errors['post_type']" class="text-danger">{{ errors['post_type'][0] }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 mt-4">
          <div class="row">
            <div class="col-md-12">
              <h3 class="text text-secondary">เนื้อหาในแต่ละภาษา *</h3>
              <div class="text-danger">(* จะต้องใส่ข้อมูลใน H1 และ Title สำหรับ th-TH และ en-UK
                ก่อนจึงจะสามารถบันทึกได้)</div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ul class="nav nav-tabs">
                <li class="nav-item" v-for="(language, langIdx) in form.languages" :key="langIdx">
                  <a class="nav-link" href="javascript:void(0);" @click="languageTabClicked(langIdx)"
                    v-bind:class="{ active: form.languages[langIdx].clicked }">
                    {{ language.name }} ({{ language.code }})

                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="row pt-1">
            <div class="col-md-12 p-4">
              <div class="tab-content">
                <div class="tab-pane" v-for="(language, langIdx) in form.languages" :key="language.id"
                  v-bind:class="{ active: form.languages[langIdx].clicked }" :id="'language_content_' + langIdx">
                  <div class="row">
                    <div class="col-md-12">
                      <p>
                        เนื้อหาในภาษา {{ language.name }} ({{ language.code }})
                      </p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Topic(H1) *</label>
                        <input default="H1" type="text" class="form-control" v-model="language.h1" />
                        <!-- <form-error
                          :isError="validateError.languages.error"
                          :errorMessage="'ยังไม่ได้ใส่ข้อมูล H1 นะจ๊ะ'"
                        ></form-error> -->
                        <span v-if="errors['languages.' + langIdx + '.h1']" class="text-danger">{{ errors['languages.' +
                          langIdx + '.h1'][0] }}</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Excerpt</label>
                        <input type="text" class="form-control" v-model="language.excerpt" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>title *</label>
                        <input type="text" class="form-control" v-model="language.title" />
                        <span v-if="errors['languages.' + langIdx + '.title']" class="text-danger">{{
                          errors['languages.' + langIdx + '.title'][0] }}</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>description</label>
                        <textarea type="text" class="form-control" v-model="language.meta_description"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:title</label>
                        <input type="text" class="form-control" v-model="language.og_title" />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:description</label>
                        <textarea type="text" class="form-control" v-model="language.og_description"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>meta keyword</label>
                        <input type="text" class="form-control" v-model="language.meta_keyword" />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:site_name</label>
                        <input type="text" class="form-control" v-model="language.og_sitename" />
                      </div>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>canonical</label>
                        <input type="text" class="form-control" v-model="language.canonical" />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>link_rel_alternate_hreflang</label>
                        <input type="text" class="form-control" v-model="language.link_rel_alternate_hreflang" />
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label>og:url</label>
                        <input type="text" class="form-control" v-model="language.og_url" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:image_width</label>
                        <input type="text" class="form-control" v-model="language.og_image_width" />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:image_height</label>
                        <input type="text" class="form-control" v-model="language.og_image_height" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:image</label>
                        <input type="text" class="form-control" v-model="language.og_image" />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:image_type</label>
                        <input type="text" class="form-control" v-model="language.og_image_type" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>twitter:site</label>
                        <input type="text" class="form-control" v-model="language.twitter_site" />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>twitter:domain</label>
                        <input type="text" class="form-control" v-model="language.twitter_domain" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>twitter:card</label>
                        <input type="text" class="form-control" v-model="language.twitter_card" />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>twitter:creator</label>
                        <input type="text" class="form-control" v-model="language.twitter_creator" />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>twitter:title</label>
                        <input type="text" class="form-control" v-model="language.twitter_title" />
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label>structured data</label>
                    <textarea row="6" type="text" class="form-control" v-model="language.structured_data"></textarea>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <ul class="nav nav-tabs">
                            <li class="nav-item" v-for="(
                                contentPart, partIdx
                              ) in language.language_parts" :key="partIdx">
                              <a :href="'#' + 'language_part_' + partIdx" class="nav-link" @click="
                                onContentPartTabClicked(
                                  langIdx,
                                  partIdx,
                                  $event
                                )
                                " v-bind:class="{ active: contentPart.clicked }">
                                เนื้อหา
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="tab-content">
                            <div class="tab-pane" v-for="(
                                contentPart, partIdx
                              ) in language.language_parts" :key="partIdx"
                              v-bind:class="{ active: contentPart.clicked }">
                              <div class="row">
                                <div class="col-md-12 text text-secondary">
                                  เนื้อหา {{ language.code }} ส่วนที่
                                  {{ contentPart.id }}
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-md-12">
                                  <iframe :id="'iframe_language_' +
                                    language.id +
                                    '_part_' +
                                    partIdx
                                    " :src="'/service' +
                                      '/' +
                                      item_id +
                                      '/language/' +
                                      language.id +
                                      '/' +
                                      partIdx +
                                      '/' +
                                      (form.languages[langIdx].language_parts[
                                        partIdx
                                      ].content == ''
                                        ? 'n'
                                        : 'y')
                                      " height="800px" width="100%" type="application/html" frameborder="0"
                                    scrolling="no" font-family="IBM Plex Sans Thai, sans-serif"></iframe>
                                  <!-- <input type="hidden" :id="'input_language_'+language.id+'_part_'+partIdx"
                                                                        v-model="form.languages[langIdx].language_parts[partIdx].content"
                                                                    > -->
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group float-right">
            <a href="javascript:void(0)" onclick="javascript:window.history.back(); return false;"
              class="btn btn-secondary">ยกเลิก</a>
            <button type="button" class="btn btn-primary ml-5" @click="saveWithGoBack()">
              บันทึก
            </button>
            <button type="button" v-if="!this.item_id" class="btn btn-primary ml-5" @click="saveWithMore()">
              บันทึก และ บันทึกเพิ่ม
            </button>
          </div>

        </div>
      </div>
    </form>
  </div>
</template>

<script>
//https://www.npmjs.com/package/vue-search-select

// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'

// import { VueEditor, Quill } from 'vue2-editor' //https://npm.io/package/vue2-quill-editor
// import { ImageResize } from 'quill-image-resize-module';
// import htmlEditButton from "quill-html-edit-button"; //เพื่อใช้ HTML view button ตอนนี้ปิดไว้ก่อน
// import QuillBetterTable from 'quill-better-table' //เพื่อใช้ table ร่วมกับ vue2-editor ตอนนี้ปิดไว้ก่อน โหลดแล้วมีปัญหา

// Quill.register({'modules/ImageResize':ImageResize,'modules/htmlEditButton':htmlEditButton});

// import SelectThumbnail from './selectThumbnail'

import VueSelectImage from "vue-select-image"; //https://npm.runkit.com/vue-select-image สำหรับเลือกภาพ thumbnail
require("vue-select-image/dist/vue-select-image.css");

import searchbox from "../_layouts/searchbox.vue";

export default {
  props: {
    item_id: "", //เก็บ id ของ cms กรณีที่เป็นการแก้ไข
  },
  components: {
    // VueEditor,
    // SelectThumbnail,
    // htmlEditButton,
    VueSelectImage,
    searchbox,
  },
  data() {
    return {
      form: {
        thumbnail: { id: "", url: "", mime_type: "" },

        thumbnail_desktop_th: { id: "", url: "", mime_type: "" },
        thumbnail_desktop_en: { id: "", url: "", mime_type: "" },
        thumbnail_mobile_th: { id: "", url: "", mime_type: "" },
        thumbnail_mobile_en: { id: "", url: "", mime_type: "" },

        banner_desktop_th: { id: "", url: "", mime_type: "" },
        banner_desktop_en: { id: "", url: "", mime_type: "" },
        banner_mobile_th: { id: "", url: "", mime_type: "" },
        banner_mobile_en: { id: "", url: "", mime_type: "" },

        service_image: [],

        category_id: "",
        slug: "",
        post_type: "service_page",
        comment_status: "disallow",
        status: "draft",
        languages: [
          {
            h1: "",
            canonical: "",
            excerpt: "",
            title: "",
            meta_description: "",
            og_title: "",
            og_description: "",
            meta_keyword: "",
            site_name: "",
            og_image: "",
            og_image_type: "",
            og_image_height: "",
            og_image_width: "",
            og_url: "",
            og_locale: "",
            twitter_card: "",
            twitter_creator: "",
            twitter_title: "",
            twitter_site: "",
            twitter_domain: "",
            link_rel_alternate_hreflang: "",
            structured_data: "",
            language_id: "",
            language_parts: [],
          }
        ],
      },
      validateError: {
        // เก็บตัวแปรผลการ submit form ว่ามีฟิลด์ไหน error บ้าง ซึ่งจะ bind กับ ตัวแปรใน <form-error> ให้เลือกเฉพาะฟิลด์ที่ต้อง validate สามารถดูว่าฟิลด์ไหน validate หรือไม่ให้ดูได้ที่ app-backend/app/controller/controller นั้นๆ
        category_id: { error: false, message: "" },
        slug: { error: false, message: "" },
        post_type: { error: false, message: "" },
        comment_status: { error: false, message: "" },
        status: { error: false, message: "" },
        languages: { error: false, message: "" },
        thumbnail: { error: false, message: "" },
        title: { error: false, message: "" },
        h1: { error: false, message: "" },
      },
      errors: {},
      languages: [
        { title: '', h1: '' },
        { title: '', h1: '' },
        { title: '', h1: '' },
      ],
      content: "",
      editorOption: {
        modules: {
          htmlEditButton: { buttonHTML: "HTML" },
          ImageResize: { displaySize: true },
          toolbar: [
            // [{ 'font': ['','Prompt','Serif','Tahoma', 'Times-new-roman', 'Arial','Monospace']  }],
            [{ font: [] }],
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["link", "image"], // link and image
            ["blockquote", "code-block"],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction

            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"], // remove formatting button
          ],
        },
        placeholder: "ใส่เนื้อหาที่นี่",
        theme: "snow",
        height: "400",
      },

      categories: {}, //เพื่อเก็บและใช้ในตัวเลือก category_id  บนฟอร์ม
      tags: [], //เพื่อเก็บและใช้ในตัวเลือก tags บนฟอร์ม
      medias: [], //thumbnail
      languages: [],

      ProductSkus: {},
      skus: [], //เพื่อเก็บและใช้ในตัวเลือก skus บนฟอร์ม

      base_url: "/cms", // base url (เปลี่ยน)

      thumbnails: [],

      thumbnails_desktop_th: [],
      thumbnails_desktop_en: [],
      thumbnails_mobile_th: [],
      thumbnails_mobile_en: [],

      banners_desktop_th: [],
      banners_desktop_en: [],
      banners_mobile_th: [],
      banners_mobile_en: [],

      service_images: [],
    };
  },
  mounted() {
    //console.log('Component mounted.')
  },
  created() {
    this.fetchLanguages();
    // this.fetchProductSkus();
  },
  methods: {
    load() {
      console.log("this.item_id >>>>>>>>>>>", this.item_id);

      axios
        .get("/service/" + this.item_id)
        .then((response) => {
          let service = response.data;
          console.log("service", service);

          if (service.tha_desktop_thumbnail_id) {
            this.form.thumbnail_desktop_th.id = service.tha_desktop_thumbnail_id;
            this.form.thumbnail_desktop_th.url = service.tha_desktop_thumbnail_url;
            this.form.thumbnail_desktop_th.mime_type = "";
          }
          if(service.eng_desktop_thumbnail_id){
            this.form.thumbnail_desktop_en.id = service.eng_desktop_thumbnail_id;
            this.form.thumbnail_desktop_en.url = service.eng_desktop_thumbnail_url;
            this.form.thumbnail_desktop_en.mime_type = "";
          }
          if(service.tha_mobile_thumbnail_id){
            this.form.thumbnail_mobile_th.id = service.tha_mobile_thumbnail_id;
            this.form.thumbnail_mobile_th.url = service.tha_mobile_thumbnail_url;
            this.form.thumbnail_mobile_th.mime_type = "";
          }
          if(service.eng_mobile_thumbnail_id){
            this.form.thumbnail_mobile_en.id = service.eng_mobile_thumbnail_id;
            this.form.thumbnail_mobile_en.url = service.eng_mobile_thumbnail_url;
            this.form.thumbnail_mobile_en.mime_type = "";
          }
          if (service.tha_desktop_cover_id) {
            this.form.banner_desktop_th.id = service.tha_desktop_cover_id;
            this.form.banner_desktop_th.url = service.tha_desktop_cover_url;
            this.form.banner_desktop_th.mime_type = "";
          }
          if (service.eng_desktop_cover_id) {
            this.form.banner_desktop_en.id = service.eng_desktop_cover_id;
            this.form.banner_desktop_en.url = service.eng_desktop_cover_url;
            this.form.banner_desktop_en.mime_type = "";
          }
          if(service.tha_mobile_cover_id){
            this.form.banner_mobile_th.id = service.tha_mobile_cover_id;
            this.form.banner_mobile_th.url = service.tha_mobile_cover_url;
            this.form.banner_mobile_th.mime_type = "";
          }
          if (service.eng_mobile_cover_id) {
            this.form.banner_mobile_en.id = service.eng_mobile_cover_id;
            this.form.banner_mobile_en.url = service.eng_mobile_cover_url;
            this.form.banner_mobile_en.mime_type = "";
          }

          service.languages[0].media.forEach((item) => {
            this.form.service_image.push({
              id: item.id,
              url: item.url,
              mime_type: "",
            });
          });

          this.form.post_type = service.post_type;
          this.form.slug = service.slug;
          this.form.status = service.status;
          // console.log("this.form.slug",this.form.slug);

          //ดึง content ในแต่ละภาษา และ ในแต่ละส่วนของภาษา
          service.languages.forEach((language, idx) => {
            this.form.languages[idx].h1 = language.h1 ? language.h1 : language.title;
            this.form.languages[idx].canonical = language.canonical ? language.canonical : language.language_id == "1" ? this.form.slug + "/" : "/en/" + this.form.slug + "/";

            this.form.languages[idx].excerpt = language.excerpt ? language.excerpt : "";
            this.form.languages[idx].title = language.title;
            this.form.languages[idx].meta_description = language.meta_description ? language.meta_description : "";
            this.form.languages[idx].og_title = language.og_title ? language.og_title : language.title;
            this.form.languages[idx].og_description = language.og_description ? language.og_description : language.meta_description ? language.meta_description : "";
            this.form.languages[idx].meta_keyword = language.meta_keyword ? language.meta_keyword : "";
            this.form.languages[idx].og_sitename = language.og_sitename ? language.og_sitename : "@loveyouflower";

            // this.form.languages[idx].og_locale = language.og_locale ? language.og_locale : language.code; // language.code undefined

            this.form.languages[idx].twitter_card = language.twitter_card ? language.twitter_card : "summary";
            this.form.languages[idx].twitter_creator = language.twitter_creator ? language.twitter_creator : "@loveyouflower";
            this.form.languages[idx].twitter_title = language.twitter_title ? language.twitter_title : language.title;
            this.form.languages[idx].twitter_site = language.twitter_site ? language.twitter_site : "https://www.loveyouflower.com/";
            this.form.languages[idx].twitter_domain = language.twitter_domain ? language.twitter_domain : "https://www.loveyouflower.com/";
            // Header For old Article
            this.form.languages[idx].header = language.header ? language.header : "";
            this.form.languages[idx].og_url = language.og_url ? language.og_url : language.language_id == "1" ? this.form.slug + "/" : "/en/" + this.form.slug + "/";
            this.form.languages[idx].og_image = language.og_image ? language.og_image : this.form.thumbnail.url;
            this.form.languages[idx].og_image_type = language.og_image_type ? language.og_image_type : this.form.thumbnail.mime_type;
            this.form.languages[idx].og_image_height = language.og_image_height ? language.og_image_height : 630;
            this.form.languages[idx].og_image_width = language.og_image_width ? language.og_image_width : 1200;
            this.form.languages[idx].link_rel_alternate_hreflang = language.link_rel_alternate_hreflang ? language.link_rel_alternate_hreflang : language.language_id == "1" ? this.form.slug + "/" : "/en/" + this.form.slug + "/";
            this.form.languages[idx].structured_data = language.structured_data ? language.structured_data : "";



            language.tags.forEach((item) => {
              // console.log("language.HERE TAG");
              this.form.languages[idx].tags.push({
                value: item.id,
                text: item.name,
              });
            });


            this.form.languages[idx].language_parts[0].content = language.language_parts[0].content;


          });

          console.log("this.form", this.form);
        })
        .catch((errors) => {
          alert("loading Error", errors);
          console.log(errors);
        });
    },
    saveWithGoBack() {
      this.save("");
    },
    saveWithMore() {
      this.save("more");
    },
    save(whatNext) {
      let save_url = "";

      //เอา content จาก summernote ใน iframe ของแต่ละภาษา และ แต่ละ part ของภาษาเข้าไปใส่ใน this.form.languages
      this.get_language_from_ifram();

      let service_image_ids = [];
      this.form.service_image.forEach((item) => {
        service_image_ids.push({ "id": item.id });
      });

      this.form.languages.forEach((item, idx) => {
        this.form.languages[idx].media = service_image_ids;
      });

      if (this.item_id != "") {
        save_url = "/service/" + this.item_id + "/update";
      } else {
        save_url = "/service/";
      }

      let me = this;

      console.log("this.form", this.form);  // return;
      axios
        .post(save_url, this.form)
        .then((response) => {
          console.log("response", response);
          // return;
          response.status == "200"
            ? whatNext == "more"
              ? window.location.href = "/service/form"
              : window.location.href = "/service"
            : alert("Error Status:");
        })
        .catch((error) => {
          console.log("error.response:", error.response)
          // || error.response.status === 422
          if (error.response ) {
            this.errors = error.response.data.message;
            alert("ไม่สามารถบันทึกได้ กรุณาใส่Content หรือ อย่าใส่content ข้ามส่วนนะจ๊ะ " + this.errors);
          }
          console.log("errors:", this.errors);
        });
    },
    get_language_from_ifram() {
      let iframe = {};
      let iWindow = {};
      let iDocument = {};
      let element = {};


      this.languages.forEach((item, langIdx) => {
        for (let partIdx = 0; partIdx <= 0; partIdx++) {
          iframe = document.getElementById(
            "iframe_language_" + item.id + "_part_" + partIdx
          );
          iWindow = iframe.contentWindow;
          iDocument = iWindow.document;

          element = iDocument.getElementById("summernote_code");

          this.form.languages[langIdx].language_parts[partIdx].content =
            element.value;

        }
      });
    },
    fetchCategories(url) {
      url = url || "/cms/fetchCategories";
      axios
        .get(url)
        .then((response) => {
          this.categories = response.data.items;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    fetchLanguages(url) {
      url = url || "/fetch/language";
      axios
        .get(url)
        .then((response) => {
          this.languages = response.data.items;

          this.languages.forEach((item, idx) => {
            this.languages[idx].title = "";
            this.languages[idx].excerpt = "";
            this.languages[idx].tags = [];
            this.languages[idx].skus = [];
            this.languages[idx].language_parts = [
              { id: 1, content: "", skus: [], clicked: true },
            ];
          });
          this.form.languages = this.languages;
          // console.log("this.form.languages line 956",this.form.languages);
          if (this.item_id) {
            this.load(); // load items ถ้ามีระบุ item_id มาจาก หน้า edit
          }
        })
        .catch((errors) => {
          alert("Unable to load Languge " + errors.message);
          console.log(errors);
        });
    },
    languageTabClicked(langIdx = 0) {
      console.log("langIdx", langIdx);
      this.form.languages.forEach((item, idx) => {
        this.form.languages[idx].clicked = false;
      });
      this.form.languages[langIdx].clicked = true;
    },
    onContentPartTabClicked(langIdx, partIdx) {
      this.languageTabClicked(langIdx);

      this.form.languages[langIdx].language_parts.forEach(function (part, y) {
        if (y == partIdx) {
          part.clicked = true;
        } else {
          part.clicked = false;
        }
      });
    },
    seachDesktopThumbnailTH(searchKeword) {
      this.thumbnails_desktop_th = [];
      this.showLoading = true;
      let url =
        "/media/list?perpage=5&mime_types=jpeg,jpg,gif,png,webp&title=" +
        searchKeword;
      axios
        .get(url)
        .then((response) => {
          let items = response.data.media;
          Object.entries(items).forEach((item, idx) => {
            this.thumbnails_desktop_th.push({
              id: item[1].id,
              src: item[1].url,
              alt: item[1].original_name,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    seachDesktopThumbnailEN(searchKeword) {
      this.thumbnails_desktop_en = [];
      this.showLoading = true;
      let url =
        "/media/list?perpage=5&mime_types=jpeg,jpg,gif,png,webp&title=" +
        searchKeword;
      axios
        .get(url)
        .then((response) => {
          let items = response.data.media;
          Object.entries(items).forEach((item, idx) => {
            this.thumbnails_desktop_en.push({
              id: item[1].id,
              src: item[1].url,
              alt: item[1].original_name,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    seachMobileThumbnailTH(searchKeword) {
      this.thumbnails_mobile_th = [];
      this.showLoading = true;
      let url =
        "/media/list?perpage=5&mime_types=jpeg,jpg,gif,png,webp&title=" +
        searchKeword;
      axios
        .get(url)
        .then((response) => {
          let items = response.data.media;
          Object.entries(items).forEach((item, idx) => {
            this.thumbnails_mobile_th.push({
              id: item[1].id,
              src: item[1].url,
              alt: item[1].original_name,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    seachMobileThumbnailEN(searchKeword) {
      this.thumbnails_mobile_en = [];
      this.showLoading = true;
      let url =
        "/media/list?perpage=5&mime_types=jpeg,jpg,gif,png,webp&title=" +
        searchKeword;
      axios
        .get(url)
        .then((response) => {
          let items = response.data.media;
          Object.entries(items).forEach((item, idx) => {
            this.thumbnails_mobile_en.push({
              id: item[1].id,
              src: item[1].url,
              alt: item[1].original_name,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    seachBannerDesktopTH(searchKeword) {
      this.banners_desktop_th = [];
      this.showLoading = true;
      let url =
        "/media/list?perpage=5&mime_types=jpeg,jpg,gif,png,webp&title=" +
        searchKeword;
      axios
        .get(url)
        .then((response) => {
          let items = response.data.media;
          Object.entries(items).forEach((item, idx) => {
            this.banners_desktop_th.push({
              id: item[1].id,
              src: item[1].url,
              alt: item[1].original_name,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    seachBannerDesktopEN(searchKeword) {
      this.banners_desktop_en = [];
      this.showLoading = true;
      let url =
        "/media/list?perpage=5&mime_types=jpeg,jpg,gif,png,webp&title=" +
        searchKeword;
      axios
        .get(url)
        .then((response) => {
          let items = response.data.media;
          Object.entries(items).forEach((item, idx) => {
            this.banners_desktop_en.push({
              id: item[1].id,
              src: item[1].url,
              alt: item[1].original_name,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    seachBannerMobileTH(searchKeword) {
      this.banners_mobile_th = [];
      this.showLoading = true;
      let url =
        "/media/list?perpage=5&mime_types=jpeg,jpg,gif,png,webp&title=" +
        searchKeword;
      axios
        .get(url)
        .then((response) => {
          let items = response.data.media;
          Object.entries(items).forEach((item, idx) => {
            this.banners_mobile_th.push({
              id: item[1].id,
              src: item[1].url,
              alt: item[1].original_name,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    seachBannerMobileEN(searchKeword) {
      this.banners_mobile_en = [];
      this.showLoading = true;
      let url =
        "/media/list?perpage=5&mime_types=jpeg,jpg,gif,png,webp&title=" +
        searchKeword;
      axios
        .get(url)
        .then((response) => {
          let items = response.data.media;
          Object.entries(items).forEach((item, idx) => {
            this.banners_mobile_en.push({
              id: item[1].id,
              src: item[1].url,
              alt: item[1].original_name,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    seachServiceImage(searchKeword) {
      this.service_images = [];
      this.showLoading = true;
      let url =
        "/media/list?perpage=5&mime_types=jpeg,jpg,gif,png,webp&title=" +
        searchKeword;
      axios
        .get(url)
        .then((response) => {
          let items = response.data.media;
          Object.entries(items).forEach((item, idx) => {
            this.service_images.push({
              id: item[1].id,
              src: item[1].url,
              alt: item[1].original_name,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    onSelectImageDesktopThumbnailTH(data) {
      this.form.thumbnail_desktop_th.url = data.src;
      this.form.thumbnail_desktop_th.id = data.id;
    },
    onSelectImageDesktopThumbnailEN(data) {
      this.form.thumbnail_desktop_en.url = data.src;
      this.form.thumbnail_desktop_en.id = data.id;
    },
    onSelectImageMobileThumbnailTH(data) {
      this.form.thumbnail_mobile_th.url = data.src;
      this.form.thumbnail_mobile_th.id = data.id;
    },
    onSelectImageMobileThumbnailEN(data) {
      this.form.thumbnail_mobile_en.url = data.src;
      this.form.thumbnail_mobile_en.id = data.id;
    },
    onSelectBannerDesktopTH(data) {
      this.form.banner_desktop_th.url = data.src;
      this.form.banner_desktop_th.id = data.id;
    },
    onSelectBannerDesktopEN(data) {
      this.form.banner_desktop_en.url = data.src;
      this.form.banner_desktop_en.id = data.id;
    },
    onSelectBannerMobileTH(data) {
      this.form.banner_mobile_th.url = data.src;
      this.form.banner_mobile_th.id = data.id;
    },
    onSelectBannerMobileEN(data) {
      this.form.banner_mobile_en.url = data.src;
      this.form.banner_mobile_en.id = data.id;
    },
    onSelectServiceImage(data) {
      // Check if the image already exists in the service_image array
      const exists = this.form.service_image.some(image => image.id === data.id);
      if (!exists) {
        this.form.service_image.push({
          id: data.id,
          url: data.src,
          alt: data.original_name,
        });
      } else {
        alert("Image already exists in the list.");
      }
    },
    removeServiceImage(index) {
      let temp = this.form.service_image;
      this.form.service_image.splice(index, 1);
      this.form.service_image = this.form.service_image.map((item, idx) => {
        return {
          ...item,
        };
      });
      console.log("this.form.service_image", this.form.service_image);
    },
  },
};
</script>
<style scoped>
.ql-editor {
  max-height: 300px !important;
  min-height: 300px !important;
  overflow: auto;
}

#language_content_0 {
  background-color: #b0c4de;
  /* Active background color */
  color: black;
  padding: 20px;
}

#language_content_1 {
  background-color: #faebd7;
  /* Active background color */
  color: black;
  padding: 20px;
}
</style>